import React from 'react';
import { OrderStatus } from '../types';

const STATUS_CONFIG: Record<OrderStatus, { label: string; bg: string; text: string; ring: string }> = {
  NEW: {
    label: '🔴 NEW',
    bg: 'bg-orange-500/20',
    text: 'text-orange-300',
    ring: 'ring-orange-500/40',
  },
  PREPARING: {
    label: '🟡 PREPARING',
    bg: 'bg-yellow-500/20',
    text: 'text-yellow-300',
    ring: 'ring-yellow-500/40',
  },
  READY: {
    label: '🟢 READY',
    bg: 'bg-emerald-500/20',
    text: 'text-emerald-300',
    ring: 'ring-emerald-500/40',
  },
  COMPLETED: {
    label: '✅ COMPLETED',
    bg: 'bg-gray-500/20',
    text: 'text-gray-400',
    ring: 'ring-gray-500/40',
  },
};

interface StatusBadgeProps {
  status: OrderStatus;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const config = STATUS_CONFIG[status];
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold ring-1 ${config.bg} ${config.text} ${config.ring} ${className}`}
    >
      {config.label}
    </span>
  );
};

export { STATUS_CONFIG };
